import React from "react";
import playIconBlue from "../../assets/images/playIconBlue.png";
import playIconGray from "../../assets/images/playIconGray.png";
import doneIcon from "../../assets/images/doneIcon.png";
import lockedIcon from "../../assets/images/lockedIcon.png";
import emptyIcon from "../../assets/images/emptyCircleIcon.png";
import { useHistory } from "react-router-dom";

const LectionItem = ({ section, courseId }) => {
  let history = useHistory();
  const icon = section.finished ? doneIcon : section.locked ? lockedIcon : emptyIcon;
  const playIcon = section.locked ? playIconGray : playIconBlue;

  return (
    <div 
      className="scrollable"
      onClick={(e) => {
        e.preventDefault();
        if(!section.locked && section.sectionType === "iFrame") {
          history.push(`/lections/playlection/${section.id}`);
        }
        if(!section.locked && section.sectionType === "Video") {
          history.push({
            pathname: `/lections/playLectionVideo/${section.id}`,
            state: {
              id: section.id,
              videoUrl: section.videoUrl,
              name: section.name,
              previewUrl: section.videoPreviewUrl,
              description: section.description,
            },
          });
        }
        if(!section.locked && section.sectionType === "PDF") {
          history.push({
            pathname: `/lections/playLectionPdf/${section.id}`,
            state: {
              id: section.id,
              pdfUrl: section.pdfUrl,
              name: section.name,
              courseId,
            },
          });
        }
        if(!section.locked && section.sectionType === "Audio") {
          history.push({
            pathname: `/lections/playLectionAudio/${section.id}`,
            state: {
              id: section.id,
              audioUrl: section.audioUrl,
              name: section.name,
              previewUrl: section.previewUrl,
              description: section.description,
            },
          });
        }
      }}
    >
      <div className="lection-item">
        <div className="lection-item-play">
          <img src={playIcon} alt="Play" />
        </div>
        <div className="lection-item-info">
          <span dangerouslySetInnerHTML={{ __html: section?.name }}></span>
          <span className="lection-item-info-time">{section.readableDuration} Minuten</span>
        </div>
        <div className="lection-item-status">
          <img src={icon} alt="Play" />
        </div>
      </div>
    </div>
  );
};

export default LectionItem;
